import { render } from "./addhuiyuan.vue?vue&type=template&id=5ca0718f&scoped=true"
import script from "./addhuiyuan.vue?vue&type=script&lang=js"
export * from "./addhuiyuan.vue?vue&type=script&lang=js"

import "./addhuiyuan.vue?vue&type=style&index=0&id=5ca0718f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca0718f"]])

export default __exports__